import { Component, Input, Output, HostListener, ViewChildren, ViewChild, ElementRef, QueryList, NgZone, EventEmitter } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

import ims from '../../imports'
import { Modal } from '@app/model/modal';
import { CommonService } from '@app/services/common.service';
import { UsersService } from '@app/services/users.service';
import { SitesService } from '@app/services/sites.service';
import { c_components } from '../..';
import { lastValueFrom } from 'rxjs';
import { BaseComponent } from '@app/directives/base-component';

@Component({
  selector: 'c_card_scheduled_arming',
  templateUrl: './c_card_scheduled_arming.component.html',
  styleUrls: ['../common.scss', './c_card_scheduled_arming.component.scss'],
  standalone: false
})
export class c_card_scheduled_arming_component extends BaseComponent {
  @Input() site;
  @Input() bridges: any;
  @Input() partition: any;
  @Output() refresh: EventEmitter<any> = new EventEmitter();
  @ViewChildren('actionMenus', {read: ElementRef}) actionMenus: QueryList<any>
  @ViewChild('armingContainer') armingContainer!: ElementRef;
  @ViewChild('amContainer') amContainer!: ElementRef;
  @ViewChild('pmContainer') pmContainer!: ElementRef;
  @ViewChild('schedulenableToggle') schedulenableToggle!: MatSlideToggle;

  me = this.usersService.me;
  dealerId = this.usersService.dealerId;
  amContainerWidth = 0;
  pmContainerWidth = 0;
  isLoading = false;
  isEditMode = false;

  m_arm_schedule: Modal = new Modal();
  m_siteArmEdit: Modal = new Modal();

  // Arming Schedule Config
  originalArmingScheduleEnabled = false;
  editArmingScheduleEnabled = false;

  //Arming Schedule
  // 1-sunday ~ 7: saturday
  weeks = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S']
  armingScheduleEnabled = true;
  _armingSchedules = {
    1: {'am':[], 'pm':[]},
    2: {'am':[], 'pm':[]},
    3: {'am':[], 'pm':[]},
    4: {'am':[], 'pm':[]},
    5: {'am':[], 'pm':[]},
    6: {'am':[], 'pm':[]},
    7: {'am':[], 'pm':[]},
  };
  armingSchedules = ims._.cloneDeep(this._armingSchedules);
  schedules = [];
  armingScheduleState = 'no-schedule';

  // add schedule
  selArmingCondition = {value:1, name:'Site to Arm'}
  selHour: string = '00';
  selMinutes: string = '00';
  selDaysOfWeek = []; // 0~7 sunday~saturday
  _schedule: any = {};


  constructor(
    private sitesService: SitesService,
    private commonService: CommonService,
    private c_components: c_components,
    private usersService: UsersService,
    private ngZone: NgZone,
  ) { super(); }

  get statusArmingSchedule(){
    return this.partition ? this.partition.arming_schedule_enabled : this.site.arming_schedule_enabled;
  }

  ngOnInit(){
    this.initData()
  }

  ngOnChanges(changes){
    if(
      changes.bridges?.currentValue &&
      (changes.bridges?.currentValue != changes.bridges?.previousValue)
    ) {
      this.setArmingScheduleState(this.schedules);
    }

    if(!changes.site?.currentValue?.site_id || !changes.site?.previousValue?.site_id) return;
    if(changes.site?.currentValue?.site_id == changes.site?.previousValue?.site_id) return
    this.initData()
  }

  initData(){
    this.isLoading = true;
    this.armingSchedules = ims._.cloneDeep(this._armingSchedules);
    this.schedules = [];
    this.originalArmingScheduleEnabled = this.partition ? this.partition.arming_schedule_enabled : this.site.arming_schedule_enabled;
    this.editArmingScheduleEnabled = this.originalArmingScheduleEnabled;
    this.armingScheduleEnabled = this.partition ? this.partition.arming_schedule_enabled : this.site.arming_schedule_enabled;
    this.fetchArmingSchedules();

    if (this.site.exp_site_info?.length > 0) {
      const partners = [...new Set(this.site.exp_site_info.map(info => info.registered_by_partner))]

      if (partners.length === 1) this.site.registered_by = partners[0]
      else this.site.registered_by = "mixed"
    }
  }

  private resizeObserver!: ResizeObserver;
  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(ims._.debounce(entries => {
        this.ngZone.run(() => {
          for (let entry of entries) {
            if (entry.target === this.amContainer.nativeElement) {
              this.amContainerWidth = entry.contentRect.width;
            } else if (entry.target === this.pmContainer.nativeElement) {
              this.pmContainerWidth = entry.contentRect.width;
            }
          }
        });
      }, 100
    ))

    if (this.amContainer?.nativeElement) {
      this.resizeObserver.observe(this.amContainer.nativeElement);
    }
    if (this.pmContainer?.nativeElement) {
      this.resizeObserver.observe(this.pmContainer.nativeElement);
    }

    this.amContainerWidth = this.amContainer.nativeElement.offsetWidth;
    this.pmContainerWidth = this.pmContainer.nativeElement.offsetWidth;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.actionMenus) {
      return;
    }
    const actionMenus = this.actionMenus.toArray();
    actionMenus.forEach(actionMenu => {
      const menuId = `${actionMenu?.nativeElement?.id}`;
      this.schedules.forEach(schedule=> {
        const scheduleId = `schedule-${schedule.id}`;
        if (scheduleId === menuId) {
          if (!actionMenu.nativeElement.contains(event.target)) {
            schedule.isShowMenu = false;
          }
        }
      })
    })
  }

  // ----------------------------------------------
  fetchArmingSchedules() {
    const dealerId = this.dealerId();
    const siteId = this.site['site_id'];
    this.armingSchedules = ims._.cloneDeep(this._armingSchedules);
    const tmpSchedules = [];

    // Partition 유무에 따라 다른 API 호출
    const apiCall = this.partition
      ? this.sitesService.getSitePartitionArmingSchedules(dealerId, siteId, this.partition.id)
      : this.sitesService.getAllArmingSchedule(dealerId, siteId);

    apiCall.subscribe(res => {
      res.forEach(schedule => {
        const dayIdx = schedule.day_of_week;
        let ampm = 'am';
        const [hour,minute,second] = schedule.start_time.split(':');
        const startTime = `${hour}:${minute}`
        const timestamp = (parseInt(hour) * 60 * 60) + (parseInt(minute) * 60);
        schedule.startTime = startTime;
        schedule.timestamp = timestamp;
        if (parseInt(hour) < 12) {
          ampm = 'am';
        } else {
          ampm = 'pm';
        }
        schedule.ampm = ampm;
        this.armingSchedules[dayIdx][ampm].push(schedule);
        tmpSchedules.push(schedule);
      })

      this.schedules = ims._.cloneDeep(tmpSchedules);
      this.setArmingScheduleState(tmpSchedules);
      this.updateOrder();
    })
  }

  async getSiteArmingSchedules(dealerId, siteId) {
    return await lastValueFrom(this.sitesService.getAllArmingSchedule(dealerId, siteId));
  }

  async getPartitionArmingSchedules(dealerId, siteId, partitionId) {
    return await lastValueFrom(this.sitesService.getSitePartitionArmingSchedules(dealerId, siteId, partitionId));
  }

  setArmingScheduleState(schedules) {
    const totalSchedule = schedules.length;
    let state = 'schedule-table';

    if (!this.checkHasCHeKTBridge()) {
      this.armingScheduleState = 'no-checkt-bridge';
      this.isLoading = false;
      return
    }
    if (!this.checkHasAllRegisteredBridge()) {
      this.armingScheduleState = 'has-unregistered-bridge';
      this.isLoading = false;
      return
    }
    if (!this.checkFiwmareVersion()) {
      this.armingScheduleState = 'not-support-firmware';
      this.isLoading = false;
      return
    }
    const armingSource = this.partition ? this.partition.arming_source : this.site.arming_source;
    if (armingSource !== 3) {
      this.armingScheduleState = 'set-arming-source';
      this.isLoading = false;
      return
    }
    if (!this.site.timezone) {
      this.armingScheduleState = 'no-timezone';
      this.isLoading = false;
      return
    }
    if (totalSchedule === 0) {
      this.armingScheduleState = 'no-schedule';
      this.isLoading = false;
      return
    }

    this.armingScheduleState = state;
    this.isLoading = false;
  }

  // Add/Edit Schedule
  isShowScheduleArmingEnagledToggle(){
    if(!this.checkHasCHeKTBridge) return false;
    if(!this.checkHasAllRegisteredBridge()) return false;
    if(!this.canControlSchedulArming()) return false;
    if(this.armingScheduleState === 'not-support-firmware') return false;
    if(this.armingScheduleState === 'set-arming-source') return false;
    if(this.armingScheduleState === 'no-timezone') return false;
    return true;
  }

  openAddArmSchedule(schedule?) {
    this.m_arm_schedule.data['schedule'] = schedule;
    this.m_arm_schedule.open();
    if(schedule) schedule.isShowMenu = false;
  }
  closeAddArmSchedule(data) {
    this.m_arm_schedule.close();
    if(!data?.target) return;

    this.selArmingCondition = data.selArmingCondition
    this.selHour = data.selHour
    this.selMinutes = data.selMinutes
    this.selDaysOfWeek = data.selDaysOfWeek
    this._schedule = data._schedule

    data?.target === 'add' ? this.add() : this.update()
  }

  addPreview(value, dayIdx){
    this.add()

    let ampm = 'am';
    const [selHour,selMinutes,second] = value.split(':');
    const startTime = `${selHour}:${selMinutes}`
    const timestamp = (parseInt(selHour) * 60 * 60) + (parseInt(selMinutes) * 60);

    let schedule = {
      id: `preview-${timestamp}`,
      day_of_week: dayIdx,
      type: 2,
      start_time: `${startTime}:00`,
      startTime: startTime,
      timestamp: timestamp,
    }

    parseInt(selHour) < 12 ? ampm = 'am' : ampm = 'pm';

    const reseult = this.isDuplicatedSchedule(dayIdx, ampm, timestamp)
    if(reseult) return;

    this.armingSchedules[dayIdx][ampm].push(schedule);
    this.updateOrder();
  }

  add(){
    if (this.selDaysOfWeek.length === 0) return;

    this.isEditMode = true;
    const selArmingType = this.selArmingCondition.value;
    const selHour = this.selHour;
    const selMinutes = this.selMinutes

    let tmpSchedules = []
    this.selDaysOfWeek.forEach(dayIdx=> {
      let ampm = 'am';
      const startTime = `${selHour}:${selMinutes}`
      const timestamp = (parseInt(selHour) * 60 * 60) + (parseInt(selMinutes) * 60);

      let schedule = {
        day_of_week: dayIdx,
        type: selArmingType,
        start_time: `${startTime}:00`,
        startTime: startTime,
        timestamp: timestamp,
      }

      parseInt(selHour) < 12 ? ampm = 'am' : ampm = 'pm';

      const reseult = this.isDuplicatedSchedule(dayIdx, ampm, timestamp)
      if(reseult) return;
      this.armingSchedules[dayIdx][ampm].push(schedule);
      tmpSchedules.push(schedule);
    })

    this.updateOrder();
    this.setArmingScheduleState(tmpSchedules);
  }

  update(){
    if (this.selDaysOfWeek.length === 0) return;

    this.isEditMode = true;
    const scheduleId = this._schedule.id;
    const dayIdx = this._schedule.day_of_week
    const [beforeSelHour, beforeMinutes] = this._schedule.start_time.split(':')

    const selArmingType = this.selArmingCondition.value;
    const selHour = this.selHour;
    const selMinutes = this.selMinutes

    // check duplicated
    let ampm = 'am';
    parseInt(selHour) < 12 ? ampm = 'am' : ampm = 'pm';
    const startTime = `${selHour}:${selMinutes}`
    const timestamp = (parseInt(selHour) * 60 * 60) + (parseInt(selMinutes) * 60);
    const reseult = this.isDuplicatedSchedule(dayIdx, ampm, timestamp)
    if(reseult) return;

    let beforeAmPm = 'am';
    parseInt(beforeSelHour) < 12 ? beforeAmPm = 'am' : beforeAmPm = 'pm';
    const targetWeek = this.armingSchedules[dayIdx][beforeAmPm]
    const target = targetWeek.find(v => v.id === scheduleId)

    target.type = selArmingType
    target.start_time = `${selHour}:${selMinutes}:00`
    target.startTime = startTime
    target.timestamp = timestamp

    this.updateOrder();
  }

  isDuplicatedSchedule(dayIdx, ampm, timestamp){
    const targetWeek = this.armingSchedules[dayIdx][ampm]
    const target = targetWeek.find(v => v.timestamp === timestamp)
    if(target) {
      alert('The same time has already been registered.')
      this.onClickCancel(true);
      return true;
    }
    return false;
  }

  updateArmingStatus(event, status, week, schedule, type){
    event?.stopPropagation()
    if(!status || !schedule || !type) return;

    const targetWeek = this.armingSchedules[week+1][type];
    const target = targetWeek.find(v => v.id === schedule.id);
    target.type = status; // 1: armed 2: disarmed
  }

  deleteSchedule(event, day, schedule, type) {
    event?.stopPropagation()
    if(!schedule || !type) return;

    this.c_components.dialog.open('warning', {
      header: 'Are you sure want to delete?',
      contents: `
        <p></b></p>
      `,
      submit_btn: 'OK',
      submit_class: ['button-primary'],
      icon : 'done',
      isConfirm : false,
      cancel_btn: 'Cancel',
      color: '#CD3D64',
      submit_func: () => {
        const targetWeek = this.armingSchedules[day+1][type] ?? []
        const targetIdx = targetWeek.findIndex(v => v.id === schedule.id)
        this.armingSchedules[day+1][type]?.splice(targetIdx, 1) // delete
      }
    })
  }

  async getArmingModeAfterSchedule(){
    const dialogResult = await this.c_components.dialog.open_and_wait_result('arming_mode_after_schedule_component', { })
    if (!dialogResult) return false;
    const { result, armingMode } = dialogResult;
    return result ? armingMode : false;
  }

  onClickCancel(isRemained = false){
    // init
    this.armingSchedules = ims._.cloneDeep(this._armingSchedules)
    this.selArmingCondition = { value:1, name:'Site to Arm' }
    this.selHour = '00';
    this.selMinutes = '00';
    this.selDaysOfWeek = []; // 0~7 sunday~saturday
    this._schedule = {};
    this.editArmingScheduleEnabled = this.originalArmingScheduleEnabled;

    const originData = ims._.cloneDeep(this.schedules)
    for(let i = 0; i < originData.length; i++) {
      const schedule = originData[i];
      const dayIdx = schedule.day_of_week;
      let ampm = 'am';

      const [hour,minute] = schedule.start_time.split(':');
      const startTime = `${hour}:${minute}`
      const timestamp = (parseInt(hour) * 60 * 60) + (parseInt(minute) * 60);
      schedule.startTime = startTime;
      schedule.timestamp = timestamp;
      parseInt(hour) < 12 ? ampm = 'am' : ampm = 'pm';
      schedule.ampm = ampm;
      this.armingSchedules[dayIdx][ampm].push(schedule);
    }

    if(!isRemained) this.isEditMode = false;
  }

  async onClickSave(){
    try {
      const armingMode = await this.getArmingModeAfterSchedule()
      if(!armingMode) return // 창만 닫자

      this.isLoading = true
      const dealerId = this.dealerId();
      const siteId = this.site.site_id;
      const data = {
        arming_schedules: this.parseArmingSchedules()
      }

      if (this.editArmingScheduleEnabled !== this.originalArmingScheduleEnabled) {
        data['arming_schedule_enabled'] = this.editArmingScheduleEnabled ? 1 : 0;
      }

      await this.updateArmingSchedules(dealerId, siteId, armingMode, data);
      this.isLoading = false;
      this.isEditMode = false;
      this.initData();
      this.commonService.showSuccessToast('Apply Site Arming Schedule', 'Success');
    } catch(err) {
      this.isLoading = false;
      this.isEditMode = false;
    }
  }

  async updateArmingSchedules(dealerId, siteId, armingMode, data) {
    const payload = data;

    if (this.partition) {
      payload['arming_action'] = armingMode;
      await lastValueFrom(this.sitesService.updateSitePartitionArmingSchedules(dealerId, siteId, this.partition.id, payload));
      this.partition.arming_schedule_enabled = this.editArmingScheduleEnabled ? 1 : 0;
    } else {
      payload['arming_mode'] = armingMode;
      await lastValueFrom(this.sitesService.updateArmingSchedules(dealerId, siteId, payload));
      this.site.arming_schedule_enabled = this.editArmingScheduleEnabled ? 1 : 0;
    }
  }

  parseArmingSchedules(){
    let result = []
    for(const week in this.armingSchedules) {
      const weekTarget = this.armingSchedules[week]
      const am = weekTarget.am
      const pm = weekTarget.pm

      am.forEach(schedule => {
        const obj = {
          day_of_week: parseInt(week),
          type: schedule.type,
          start_time: schedule.start_time
        }
        result.push(obj)
      })
      pm.forEach(schedule => {
        const obj = {
          day_of_week: parseInt(week),
          type: schedule.type,
          start_time: schedule.start_time
        }
        result.push(obj)
      })
    }
    return result;
  }

  // ----------------------------------------------
  // STYLE / Tool
  amHoveredTime = { 1:'', 2:'', 3:'', 4:'', 5:'', 6:'', 7:''};
  pmHoveredTime = { 1:'', 2:'', 3:'', 4:'', 5:'', 6:'', 7:''};

  onMouseMove(event: MouseEvent, week, type) {
    if(!this.isEditMode) return;
    if(type === 'am') {
      const rect = this.amContainer.nativeElement.getBoundingClientRect();
      const relativeX = event.clientX - rect.left; // container 내부 상대 좌표
      this.amHoveredTime[week+1] = this.getTimeFromPosition(relativeX, this.amContainerWidth, false)
    } else {
      const rect = this.pmContainer.nativeElement.getBoundingClientRect();
      const relativeX = event.clientX - rect.left; // container 내부 상대 좌표
      this.pmHoveredTime[week+1] = this.getTimeFromPosition(relativeX, this.pmContainerWidth, true);
    }
  }
  onMouseLeave(type, week){
    if(type === 'am') {
      this.amHoveredTime[week+1] = ''
      this.pmHoveredTime = { 1:'', 2:'', 3:'', 4:'', 5:'', 6:'', 7:''}
    } else {
      this.pmHoveredTime[week+1] = ''
      this.amHoveredTime = { 1:'', 2:'', 3:'', 4:'', 5:'', 6:'', 7:''}
    }
  }
  getTimeFromPosition(x: number, containerWidth: number, isPm: boolean = false): string {
    if (x < 0) x = 0;
    if (x > containerWidth) x = containerWidth;

    // 12시간 = 720분
    const minutesPerPixel = 720 / containerWidth;
    let minutes = Math.round(x * minutesPerPixel);

    if (isPm) minutes += 720;

    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;

    return `${hour.toString().padStart(2,'0')}:${minute.toString().padStart(2,'0')}`;
  }
  updateOrder(){
    Object.keys(this.armingSchedules).forEach(key => {
      this.armingSchedules[key]['am'].sort((a,b)=> a.timestamp - b.timestamp);
      this.armingSchedules[key]['pm'].sort((a,b)=> a.timestamp - b.timestamp);
    })
  }
  updateDrag(result){
    const { schedule, week, dynamicIsPm, isPm } = result;

    if(!isPm && dynamicIsPm) this.moveScheduleToPm(schedule, week+1)
    if(isPm && !dynamicIsPm) this.moveScheduleToAm(schedule, week+1)
    this.updateOrder()

    const containerWidth = dynamicIsPm ? this.pmContainerWidth : this.amContainerWidth;
    this.getTimeXPosition(schedule.startTime, containerWidth, dynamicIsPm)
  }

  moveScheduleToAm(schedule: any, dayIndex: number) {
    this.armingSchedules[dayIndex].pm =
      this.armingSchedules[dayIndex].pm.filter(s => s.id !== schedule.id);

    this.armingSchedules[dayIndex].am.push(schedule);
  }
  moveScheduleToPm(schedule: any, dayIndex: number) {
    this.armingSchedules[dayIndex].am =
      this.armingSchedules[dayIndex].am.filter(s => s.id !== schedule.id);

    this.armingSchedules[dayIndex].pm.push(schedule);
  }


  setScheduleEditIcon(apiKey) {
    if(!apiKey || !this.isEditMode) return;
    if (!(this.dealerId() === this.site.dealer_id || this.site.dealer_type===3)) return;
    apiKey.isShowMenu = true;
  }
  closeScheduleEditIcon(apiKey) {
    if(!apiKey || !this.isEditMode) return;
    if (!(this.dealerId() === this.site.dealer_id || this.site.dealer_type===3)) return;
    apiKey.isShowMenu = false;
  }

  getTimeXPosition(time: string, containerWidth: number, isPm: boolean = false): number {
    if(!time) return;

    const [hour, minute] = time.split(':').map(Number);
    const totalMinutes = hour * 60 + minute;

    if (!isPm) {
      return (totalMinutes / 720) * containerWidth;
    } else {
      const pmMinutes = totalMinutes - 720;
      return (pmMinutes / 720) * containerWidth;
    }
  }

  changeEditMode(){
    this.isEditMode = true
  }

  computedScheduleStyleClass(schedule){
    if(schedule.type === 1) return 'arm';
    if(schedule.type === 2) return 'disarm';
    if(!this.site.arming_schedule_enabled) return 'disable-schedule';
    return ''
  }
  checkHasCHeKTBridge(){
    return this.bridges.some(v => v.type === 11 && v.registered_by_partner.toLowerCase() === 'chekt')
  }
  checkHasAllRegisteredBridge(){
    if(!this.checkHasCHeKTBridge()) return false;
    return this.bridges.every(v => v.is_registered)
  }
  checkFiwmareVersion() {
    let isSupport = true;
    this.bridges?.forEach(bridge => {
      let firmVersion = '';
      if (bridge?.registered_by_partner != 'chekt') return;
      if (bridge.firmware_version) {
        try {
          firmVersion = JSON.parse(bridge.firmware_version).bridge.replace('V', '').split('.').slice(0, 4).join('.');
        } catch {
        }
      }
      if (!firmVersion || !ims.tool.firmware_version_greater_than_or_equal_to(firmVersion, '3.4.2.1')) {
        isSupport = false;
      }
    })
    return isSupport;
  }
  // -----------------------------------
  canControlSchedulArming(){
   return this.dealerId() === this.site?.dealer_id || ( this.me()?.type === 2 && this.site.dealer_type === 3 )
  }
  canEditShceuldArming(){
    return this.dealerId() === this.site?.dealer_id || this.site?.dealer_type === 3
  }

  canEdit() {
    const isDealerMatch = this.dealerId() === this.site.dealer_id 
    const isValidType = this.me()?.type === 2

    return (isDealerMatch || isValidType) && !this.isExternalSite()
  }

  isExternalSite() {
    return this.site.registered_by
  }

  openArmEdit() {
    if (this.dealerId() !== this.site['dealer_id'] && this.me()?.type !== 2) return;
    this.m_siteArmEdit.data['site'] = this.site;
    this.m_siteArmEdit.open();
  }

  closeArmEdit() {
    this.refresh.emit()
  }

  goToDeviceList() {
    this.commonService.emitSiteTab([{name: 'Devices', link: 'devices/device-list'}]);
  }
  goToGeneralTab() {
    this.commonService.emitSiteTab([{name: 'General', link: 'general'}]);
  }

}
